import { CustomCellDate, CrudLink } from "@/shared/components";
import { Chip, Stack, Typography } from "@mui/material";
import type { DataListViewColumns } from "@/shared/components/DataListView";
import type { CollectionTypeRow } from "./types";
import type { ColumnDefinition } from "@/shared/components/CRUD/types";

export const getColumnsConfig = (): ColumnDefinition<CollectionTypeRow>[] => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "title",
    label: "Название",
    options: {
      setCellHeaderProps: () => ({ style: { minWidth: 200 } }),
      customBodyRender: (data: unknown) => {
        const row = data as CollectionTypeRow;
        return (
          <CrudLink id={row.id} tab="edit">
            {row.title}
          </CrudLink>
        );
      },
    },
  },
  {
    name: "showInSearch",
    label: "В поиске",
    options: {
      setCellHeaderProps: () => ({ style: { width: 120 } }),
      customBodyRender: (value: unknown) => (
        <Chip
          label={value ? "Да" : "Нет"}
          color={value ? "success" : "default"}
          size="small"
        />
      ),
    },
  },
  {
    name: "collectionDisplayMode",
    label: "Режим превью",
    options: {
      setCellHeaderProps: () => ({ style: { width: 160 } }),
      customBodyRender: (value: unknown) =>
        value === "HORIZONTAL"
          ? "Горизонтальный"
          : value === "VERTICAL"
            ? "Вертикальный"
            : "Дефолт",
    },
  },
  {
    name: "createdAt",
    label: "Создан",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => (
        <CustomCellDate date={value as string} />
      ),
    },
  },
];

export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Типы коллекций",
  itemCreated: "Тип коллекции создан",
  itemUpdated: "Тип коллекции обновлён",
  createItem: "Добавить тип",
  refetchList: "Обновить список",
  deleteItems: "Удалить",
  itemsDeleted: "Удалено",
  restoreItems: "Восстановить",
  itemsRestored: "Восстановлено",
  cancel: "Отмена",
  editItem: "Тип коллекции",
  showTitle: "Детали",
});

// Колонки для мобильного представления: название с режимом превью и признак поиска
export const getMobileColumnsConfig =
  (): DataListViewColumns<CollectionTypeRow> => ({
    main: {
      title: "Тип коллекции",
      sx: { flex: 1, minWidth: 0 },
      renderCell: (row) => (
        <Stack sx={{ minWidth: 0 }}>
          <CrudLink id={row.id} tab="edit" noWrap>
            {row.title}
          </CrudLink>
          <Typography variant="body2" color="textSecondary" noWrap>
            {row.collectionDisplayMode === "HORIZONTAL"
              ? "Горизонтальный"
              : row.collectionDisplayMode === "VERTICAL"
                ? "Вертикальный"
                : "Дефолт"}
          </Typography>
        </Stack>
      ),
    },
    showInSearch: {
      title: "В поиске",
      sx: { width: 72, flexShrink: 0 },
      renderCell: (row) => (
        <Chip
          label={row.showInSearch ? "Да" : "Нет"}
          color={row.showInSearch ? "success" : "default"}
          size="small"
        />
      ),
    },
  });
